import React from 'react';
import chatPerson from "../../../images/img/chat-person.png"
// import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import Calender from '../../Calender';
import DatePicker from '../../FormFields/DatePicker';

const MessageA5 = (props) => {
//    console.log("adateprops",props);
   const dateData = props.item && props.item.text_data;

    const parentCallback = (data) =>{
        // console.log("parentCallback",data)
        localStorage.setItem("inputValue",JSON.stringify({key1:data}));
    }
   const initialDate = props.userInputObj && props.userInputObj.key1;

    return(
        <>
            <div>
                <div style={{display:'flex',width:'100%'}}>
                <div className="chat-person" style={{ marginTop: '10px' }}>
                    <img src={chatPerson} alt="" />
                </div> <div className="chat-text" style={{ margin: '10px 0px' }} >
                    {props.item.text}  </div>
                    </div>
                {/* <Calender dateSelect={props.item.data} /> */}
                {/* <DatePicker
                    placeholderText="Select Date"
                    name="startDate"
                    onChange={(date) => handleChange(date)}
                    dateFormat="dd-MM-yyyy"
                    required
                > </DatePicker> */}
                <DatePicker {...props} parentCallback={parentCallback} dateData={dateData} initialDate={initialDate}/>
            </div>
        </> 
    )
}


export default MessageA5;
